var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.9675,
    y: 35.9065,
    width: 11.7717,
    height: 11.7717,
    rx: 3.42461,
    fill: "#EEEEF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7797 0.429688H24.3143C23.1063 0.429688 22.0071 1.1278 21.4936 2.22119L2.22863 43.2369C1.25789 45.3036 2.766 47.6782 5.04937 47.6782H17.7218C18.9345 47.6782 20.037 46.9747 20.548 45.875L39.6059 4.85927C40.5657 2.7936 39.0574 0.429688 36.7797 0.429688Z",
    fill: "#EEEEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7469 0.429688H75.0899C77.3651 0.429688 78.8734 2.78868 77.9187 4.85383L69.8232 22.3646C69.3134 23.4673 68.2093 24.1732 66.9945 24.1732H49.7774L58.8967 43.2158C59.8873 45.2843 58.3795 47.6782 56.086 47.6782H43.6439C42.4356 47.6782 41.3362 46.9797 40.8228 45.8859L32.7159 28.6137C31.7459 26.547 33.254 24.1732 35.537 24.1732H49.7774L59.9182 2.23832C60.428 1.13563 61.5321 0.429688 62.7469 0.429688Z",
    fill: "#EEEEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.217d3dee2efa86bb2b47771fa2149fa3.svg";
export { ForwardRef as ReactComponent };